import React from "react";
import PeruFlag from "../../../assets/country-flags/perú_flag.png";
import ChileFlag from "../../../assets/country-flags/chile_flag.png";

export default function DmCountryFlag(props) {
  const { countryCode, className, style } = props;
  switch (countryCode) {
    case "PE":
      return <img src={PeruFlag} alt="" className={className} style={style} />;
    case "CL":
      return <img src={ChileFlag} alt="" className={className} style={style} />;
    default:
      return null;
  }
}
